export default "__VITE_ASSET__76ff5c27__"